import {
  DatePicker,
  UkAddressSearch,
  TextInput,
  Title,
  AddressType,
} from "@simplecitizen/gdl-react-ui-components";
import {  formatISO } from "date-fns";
import { useMemo, useState } from "react";
import { FieldErrors, useController, UseFormRegister } from "react-hook-form";
import { useAppSelector } from "src/hooks/redux-hooks";
import { parceDateStringToDate, validateInputDate } from "src/utils/utils";

interface ExperianQuestionsProps {
  control: any;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>
  setExperianFullAddress: React.Dispatch<any>
}

const ExperianQuestions = ({ control,register,errors,setExperianFullAddress }: ExperianQuestionsProps) => {
  const profile = useAppSelector((state) => state.profileData);
  const [dateValue,setDateValue] = useState(new Date(profile.profile.birth.date))
  const { field: primaryResidentialAddressField } = useController({
    name: "googleResidentialAddress",
    control,
    rules:{
      required:'Primary residential address is required',
  
    }
  });

  const { field: dateOfBirthField } = useController({
    name: "experianDateOfBirth",
    control,
    defaultValue: profile.profile.birth.date ? formatISO(parceDateStringToDate(profile.profile.birth.date)!,{ representation: 'date' })   : '',
    rules:{
      required:'Date of birth is required',
      validate: (value)=>  validateInputDate(value,true),
    }
  });
  const fields = useMemo(() => {
    return [
  
   
      {
        label: "Date of Birth",
        required:true,
        name: "experianDateOfBirth",
        error_message:errors['experianDateOfBirth']?.message,
        type: "date",
        disableFutureDates: true,
        value: dateValue
       ,
          onChange: (e:any)=>{
     
            dateOfBirthField.onChange(e.target.value);
          },
        onDateChange: (date: Date) => {
          const formattedDate = formatISO(date,{ representation: 'date' })
          setDateValue(date)
           dateOfBirthField.onChange(formattedDate);
        },
      },
   
      {
        label: "Primary residential address",
        error_message:errors['googleResidentialAddress']?.message,
        required:true,
        name: "primaryAddress",
        type: "location-search",
        onSelectLocation: (value: any) => {
          primaryResidentialAddressField.onChange(
            value.geo_results[0].formatted_address
          );
        },
      },
   
    ];
  }, [dateOfBirthField, primaryResidentialAddressField,errors,dateValue]);
  const client = useAppSelector(
    (state) => state.questionnaire_data.questionnaire?.client
  );

 const cleanAddress = (address: AddressType): AddressType => {
   const cleanValue = (value: string | undefined) =>
       value?.replace(/[\\/]+/g, " ").replace(/\s+/g, " ").trim();

   return {...address,
     buildingNumber: cleanValue(address.buildingNumber),
     buildingName: cleanValue(address.buildingName),
     apartmentOrUnitNumber: cleanValue(address.apartmentOrUnitNumber),
     district: cleanValue(address.district),
     county: cleanValue(address.county),
     postalCode: cleanValue(address.postalCode),
     streetName: cleanValue(address.streetName),
     city: cleanValue(address.city),
   }
  }

  return (
    <div className="w-full mt-6">
      <Title className="mt-3 mb-3">Identity Check Questions</Title>
      <div className="flex flex-col">
        {fields.map(({ name, type, ...field }) => (
          <div key={name} className="">
            {type === "text" && (
              <TextInput
                className=""
                labelClassName="font-normal "
                name={name}
                {...field}
              />
            )}
          
            {
              type === "location-search" && (
                <UkAddressSearch
                  apiKey={process.env.REACT_APP_GET_ADDRESS_API_KEY!}
                  placeholder="Search for your UK address"
                  label={field.label}
                  showAddressDetails={true}
                  className="mb-2"
                  error_message={field.error_message as string | null | undefined}
                  onAddressSelected={({ formattedAddress }) => {
                    primaryResidentialAddressField.onChange(formattedAddress);
                  }}
                  onAddressChange={(address: AddressType | null) => {
                    if (address) {
                      const clean_address = cleanAddress(address)

                      const structured_address = {
                        "building number": clean_address.buildingNumber || "",
                        "building name": clean_address.buildingName || "",
                        "apartment number": clean_address.apartmentOrUnitNumber || "",
                        "district": clean_address.district || "",
                        "county": clean_address.county || "",
                        "postal code": clean_address.postalCode || "",
                        "street": clean_address.streetName || "",
                        "town": clean_address.city || "",
                      };
                      setExperianFullAddress(structured_address);

                      const formatted = [
                        address.buildingNumber,
                        address.buildingName,
                        address.streetName,
                        address.city,
                        address.postalCode,
                      ]
                        .filter(Boolean)
                        .join(", ");
                      primaryResidentialAddressField.onChange(formatted);
                    }
                  }}
                />
              )
            }
          
            {type === "date" && (
              <DatePicker
              onChange={field.onChange}
              error_message={field.error_message}
                disableFutureDates={field.disableFutureDates}

                className=""
                color={client?.branding?.primaryColor || "#0A71C7"}

                labelClassName="font-normal"
                onDateChange={field.onDateChange!}
                value={(profile.profile.birth.date ? parceDateStringToDate(profile.profile.birth.date) : new Date()) as Date}
                label={field.label}
                placeholder="DD/MM/YYYY"
                required={field.required}
                initialValue={profile.profile.birth.date ? parceDateStringToDate(profile.profile.birth.date) : undefined}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExperianQuestions;
